import { RouteConfig } from "vue-router";
import LoginComponent from "./login.vue";
import RegisterComponent from "./register.vue";
import ResetPasswordComponent from "./reset-password.vue";
import NewPasswordComponent from "./new-password.vue";
import ConfirmedEmailComponent from "./confirmed-email.vue";

export default [
  {
    path: "/login",
    name: "Login",
    component: LoginComponent
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterComponent
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPasswordComponent
  },
  {
    path: "/new-password/:email/:token",
    name: "NewPassword",
    component: NewPasswordComponent
  },
  {
    path: "/confirmed-email",
    name: "ConfirmedEmail",
    component: ConfirmedEmailComponent
  }
] as RouteConfig[];